import { useEffect, useState } from "react";
import "../roomy.css";

// "Roomy" desktop layout (wider pages, slightly bigger text) vs the original "Classic" one; saved per computer
export function useRoomy() {
  const [roomy, setRoomy] = useState(() => localStorage.getItem("aqualux:layout") !== "classic");
  useEffect(() => {
    const el = document.documentElement;
    const apply = () => el.classList.toggle("roomy", roomy && window.innerWidth >= 1680);
    apply();
    window.addEventListener("resize", apply);
    return () => { window.removeEventListener("resize", apply); el.classList.remove("roomy"); };
  }, [roomy]);
  const toggle = () => setRoomy((r) => { localStorage.setItem("aqualux:layout", r ? "classic" : "roomy"); return !r; });
  return [roomy, toggle];
}
